// extracted by mini-css-extract-plugin
module.exports =  {"tc-tile-footer":"TileFooter-module__tc-tile-footer___Y_RxZ"};